export const NAME_MIN_LENGTH: number = 0;
export const NAME_MAX_LENGTH: number = 100;
export const PET_PARENT_NAME_MAX_LENGTH: number = 40;
